module.exports = __webpack_public_path__ + "img/FLDCOMP.3868fc39.svg";